import type {
  SecondaryPostEventsLimitOrderPersistedTabContent,
  SecondaryQuotesLimitOrderFormPersistedTabContent,
} from 'apiConnector/tabs/secondaryMarket.tabs.model';
import type { LimitOrderInputForm } from 'state/secondaryMarket/limit-order/form/input/inputForm.model';
import { limitOrderFormSelectorFactory } from 'state/secondaryMarket/limit-order/form/shared/selectors';
import { formInputSelectorsFactory } from 'state/secondaryMarket/shared/form/input/input.selector';
import { fromSecondaryPostEventsWorkspace, fromSecondaryQuotesWorkspace } from 'state/selectors';
import type { AppState } from 'state/state.model';
import { fromBcsProductKey } from 'state/workspaces/secondary-market/quotes/secondartMarketQuotes.shared';

const selectors = limitOrderFormSelectorFactory<LimitOrderInputForm>('input');

function getFormTabContentToPersist(
  appState: AppState,
  tabId: string,
): SecondaryQuotesLimitOrderFormPersistedTabContent | undefined {
  const state = selectors.select(appState, tabId);
  if (state === undefined) {
    return undefined;
  }
  const { client, clientType, ...form } = state;
  const bcskey = fromSecondaryQuotesWorkspace.getProductKey(appState, tabId);

  return {
    client,
    clientType: clientType ?? 'Other',
    ...form,
    bcsProductKey: bcskey,
    workspace: 'secondaryMarketQuotes',
    tabType: 'limitOrder',
  };
}

function getAmendFormTabContentToPersist(
  appState: AppState,
  tabId: string,
): SecondaryPostEventsLimitOrderPersistedTabContent | undefined {
  const state = selectors.select(appState, tabId);
  if (state === undefined) {
    return undefined;
  }
  const { client, clientType, ...form } = state;
  const bcskey = fromBcsProductKey(fromSecondaryPostEventsWorkspace.getBcsProductKey(appState, tabId))!;
  return {
    client,
    clientType: clientType ?? 'Other',
    ...form,
    bcsProductKey: bcskey,
    workspace: 'secondaryMarketPostEvents',
    tabType: 'limitOrder',
  };
}

export const limitOrderInputFormSelectors = formInputSelectorsFactory('limitOrder', {
  getFormTabContentToPersist,
  getAmendFormTabContentToPersist,
  getLimit: selectors.getLimit,
  getSalesMarginAdjustment: selectors.getSalesMarginAdjustment,
});

export type LimitOrderInputFormSelectors = typeof limitOrderInputFormSelectors;
